import React, { Component } from "react"
import { inject, observer } from "mobx-react"
import styled from "styled-components"

// import Tooltip from '~/components/Tooltip'
import withTranslations from "~/components/_hocs/withTranslations"
import Input from "~/components/Form/LandingInput"
import Spacer from "~/components/Spacer"
import FormError from "~/components/Form/ErrorText"
import InputTitle from "./InputTitle"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 364px;
  width: 100%;
`

@inject(all => ({
  validateDisplayMessage:
    all.store.parkingFlow.searchCriteria.validateDisplayMessage,
  setPlateNumber: all.store.parkingFlow.searchCriteria.setPlateNumber,
  plateNumber: all.store.parkingFlow.searchCriteria.plateNumber
}))
@observer
class PlateNumber extends Component {
  handleChange = e => {
    this.props.setPlateNumber(e.target.value)
  }

  render() {
    const plateNumberError = this.props.validateDisplayMessage("plateNumber")
    return (
      <Wrap>
        <InputTitle>
          {this.props.translate('label')}
          <Spacer direction="width" mobile={11} desktop={11} />
        </InputTitle>
        <Spacer desktop={16} mobile={16} />
        <Input
          placeholder="Ex: ABC123"
          onChange={this.handleChange}
          onKeyDown={this.props.onEnterSubmit}
          value={this.props.plateNumber}
          error={plateNumberError}
          maxLength={9}
        />
        <FormError error={plateNumberError} />
      </Wrap>
    )
  }
}

export default withTranslations(PlateNumber, 'form.parking.plateNumber')
